import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { initializeApp } from 'firebase/app'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

// Initialize the Firebase app once at bootstrap (vanilla modular SDK, replacing
// @angular/fire). getMessaging()/getToken() in NotificationService use the
// default app registered here.
initializeApp(environment.firebaseConfig)

// Disable ApexCharts entry/dynamic animations globally. The reveal animation
// (runMaskReveal) fires on a setTimeout and throws "Cannot read properties of
// null (reading 'node')" when a chart re-renders before the timer fires.
;(window as any).Apex = { chart: { animations: { enabled: false } } }

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()]
  })
  .catch((err) => console.error(err))

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('firebase-messaging-sw.js')
    .then(() => {})
    .catch(() => {})
}
